module.exports = __webpack_public_path__ + "images/71e8c1e165cbaf37a851acf9199e533e.payments.svg";